module.exports = __webpack_public_path__ + "static/img/icon-pk.b59ce745.png";